export var TranslationNamespaces = /*#__PURE__*/ function(TranslationNamespaces) {
    TranslationNamespaces["Strings"] = "strings";
    return TranslationNamespaces;
}({});
export const PLAYER_DISPLAY_NAME_START = '\uE000';
export const PLAYER_DISPLAY_NAME_END = '\uE001';
